var exports = {
  "button": "MediaPlayButton.module__button___RzRyen",
  "small": "MediaPlayButton.module__small___RzRyen",
  "medium": "MediaPlayButton.module__medium___RzRyen",
  "large": "MediaPlayButton.module__large___RzRyen",
  "xlarge": "MediaPlayButton.module__xlarge___RzRyen",
  "overlay": "MediaPlayButton.module__overlay___RzRyen",
};

__webpack_require__.r(module.exports = exports);
